import { z } from "zod";

/** A source outside Pax, recorded by an importer rather than inferred from the item's contents. */
export const ExternalCreationSource = z
  .strictObject({
    kind: z.literal("external"),
    name: z.string().min(1).max(120),
    url: z.url().refine(url => ["https:", "http:"].includes(new URL(url).protocol), "An HTTP link"),
    sourceId: z.string().min(1).max(200),
    version: z.string().min(1).max(100).optional(),
  })
  .meta({
    id: "ExternalCreationSource",
    description: "The external source a version was imported from.",
  });
export type ExternalCreationSource = z.infer<typeof ExternalCreationSource>;

/** The sources of a version, starting with its immediate parent and ending at its origin. */
export const CreatedFrom = z
  .array(
    z.discriminatedUnion("kind", [
      z.strictObject({ kind: z.literal("original") }),
      ExternalCreationSource,
      z.strictObject({
        kind: z.literal("version"),
        itemId: z.uuid(),
        versionId: z.uuid(),
        title: z.string(),
        url: z.string().startsWith("/"),
        version: z.int().positive(),
      }),
      z.strictObject({ kind: z.literal("unavailable") }),
    ]),
  )
  .min(1)
  .meta({ id: "CreatedFrom", description: "A version's immediate parent and its origin." });
export type CreatedFrom = z.infer<typeof CreatedFrom>;
